var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32925)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#6356AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.816 8.98537C12.8486 8.94881 12.8852 8.91225 12.9218 8.87512C13.0399 8.748 13.1692 8.61244 13.2913 8.48138C13.7803 7.97159 14.0538 7.29274 14.0546 6.58631C14.0546 6.53737 14.0625 6.336 14.0625 6.30731C14.0057 4.69181 12.6456 3.375 11.0379 3.375H5.97544V5.41744H3.9375V14.625H11.1189C12.7148 14.625 14.0625 13.2058 14.0625 11.5245C14.0664 10.3224 13.3234 9.47363 12.816 8.98537ZM6.99019 6.44288L11.0216 6.44681L8.48869 9.01462L10.9935 11.5571H6.99019V6.44288ZM11.1189 13.5956H4.95225V6.43894H5.976V12.5786H10.9935C11.4075 12.5786 11.7771 12.3283 11.9351 11.943C12.013 11.7555 12.0337 11.5491 11.9946 11.3499C11.9556 11.1506 11.8586 10.9674 11.7157 10.8231L9.92587 9.01012L11.7444 7.1685C12.0369 6.87319 12.1219 6.43444 11.9638 6.04912C11.8879 5.86142 11.7577 5.70065 11.5898 5.58741C11.4219 5.47418 11.2241 5.41362 11.0216 5.4135H6.99412V4.3965H11.0419C12.114 4.3965 13.0151 5.27006 13.0517 6.33206C13.0517 6.37706 13.0433 6.55369 13.0433 6.55763V6.57788C13.0432 7.02327 12.8702 7.45123 12.5606 7.7715C12.4346 7.90312 12.3047 8.04206 12.1871 8.16525C11.988 8.3745 11.8176 8.55506 11.736 8.63719L11.3704 8.99775L11.7321 9.36337C11.781 9.41231 11.8417 9.46969 11.9149 9.53944C12.3368 9.93319 13.0477 10.5891 13.0477 11.5161C13.0517 12.6236 12.1506 13.5956 11.1189 13.5956Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32925"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBay);
export default __webpack_public_path__ + "static/media/bay.55fc2de30836ecfc7fa037da61e60ea8.svg";
export { ForwardRef as ReactComponent };